/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} List_NameInputs */

const en_list_name = /** @type {(inputs: List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List Name`)
};

const fr_list_name = /** @type {(inputs: List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de la liste`)
};

const de_list_name = /** @type {(inputs: List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listenname`)
};

const it_list_name = /** @type {(inputs: List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome elenco`)
};

const ru_list_name = /** @type {(inputs: List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название списка`)
};

const es_list_name = /** @type {(inputs: List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la lista`)
};

const zh_cn2_list_name = /** @type {(inputs: List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`列表名称`)
};

const ja_list_name = /** @type {(inputs: List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リスト名`)
};

const hi_list_name = /** @type {(inputs: List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम की सूचि`)
};

const pt_pt2_list_name = /** @type {(inputs: List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da lista`)
};

/**
* | output |
* | --- |
* | "List Name" |
*
* @param {List_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const list_name = /** @type {((inputs?: List_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<List_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_list_name(inputs)
	if (locale === "de") return de_list_name(inputs)
	if (locale === "it") return it_list_name(inputs)
	if (locale === "ru") return ru_list_name(inputs)
	if (locale === "es") return es_list_name(inputs)
	if (locale === "zh-CN") return zh_cn2_list_name(inputs)
	if (locale === "ja") return ja_list_name(inputs)
	if (locale === "hi") return hi_list_name(inputs)
	if (locale === "pt-PT") return pt_pt2_list_name(inputs)
	return en_list_name(inputs)
});